import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  constructor(private router: Router) {}

  public getElements(elements: any, page: number, limit?: number): any {
    if (elements && limit) {
      // Return a shallow copy of the array
      return elements.slice(Math.max(page - 1, 0) * limit, page * limit);
    } 
    else {
      // As limit can be undefined => all elements are displayed
      return elements;
    }
  }
}
